export default __webpack_public_path__ + "static/media/messages-people-user-bubble-circle.f40f7404.svg";